import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ProductItemProductFragmentDoc } from './ProductItemProduct.generated'
import * as Types from './purchasePlus_graphql'

export const ProductPreviewProductFragmentDoc = gql`
  fragment ProductPreviewProduct on ProductInterface {
    id
    image
    itemDescription
    category {
      id
      name
      parent {
        id
        name
      }
    }
    ...ProductItemProduct
  }
  ${ProductItemProductFragmentDoc}
` as unknown as DocumentNode<Types.ProductPreviewProductFragment, unknown>
